import React, { FunctionComponent } from 'react';

import {
  ReviewsOverviewTitle,
  ReviewsOverviewStarsText,
  ReviewsOverviewArea
} from './styles';

import { ReviewStarsOverall } from './ReviewStars';

const OverallReviewArea: FunctionComponent<{
  score: number;
  count: number;
}> = ({ score, count }) => {
  return (
    <ReviewsOverviewArea>
      <ReviewsOverviewTitle>OVERALL RATING</ReviewsOverviewTitle>
      <ReviewStarsOverall score={score} large />
      <ReviewsOverviewStarsText>
        {`${score.toFixed(1)} OUT OF 5 (${count} Reviews)`}
      </ReviewsOverviewStarsText>
    </ReviewsOverviewArea>
  );
};

OverallReviewArea.defaultProps = {};

export default OverallReviewArea;
